<template>
	<div class="d21-productSet mdl-cell--12-col">
		<div class="mdl-grid d21-productSet-grouping" v-if="showEachSet || groupedSets.length !== Reservation.MultiDate.Sets.length">
			<div class="mdl-cell mdl-cell--12-col">
				<toggle-button v-model="showEachSet" :labels="{ checked: T('yes'), unchecked: T('no')}" />
				<label>{{ T("ticketing_list_all_dates_individually") }}</label>
			</div>
		</div>
		<template v-for="(set, setIndex) in groupedSets">
			<div class="mdl-grid d21-productSet-product" :key="'set_' + setIndex">
				<div class="mdl-cell mdl-cell--12-col d21-productSet-name">
					<span class="name">{{ set.name }}</span>
					<span class="small">{{ getProductNames(set) }}</span>
				</div>
				<template v-if="!channel.Fields.IsOnlyBuyer">
					<template v-for="(product, pIndex) in set.products">
						<template v-for="(tariff, tIndex) in product.Tariffs">
							<div v-for="(occupancy, oIndex) in tariff.Occupancy" :key="'occupancy_' + + setIndex + '_' + pIndex + '_' + tIndex + '_' + oIndex" class="d21-productSet-person mdl-grid mdl-cell mdl-cell--12-col">
								<div class="mdl-cell mdl-cell--1-col mdl-cell--1-col-m d21-product-occupancy-index">
									<span>{{ pIndex + oIndex + 1 }}</span>
								</div>
								<div class="mdl-cell mdl-cell--3-col mdl-cell--5-col-m form-group d21-firstname">
									<ValidationProvider rules="required|min:2|alpha_spaces" v-slot="{ errors }">
										<input :name="'firstname'" type="text" class="mdl-textfield__input" data-lpignore="true" :placeholder="T('firstname')" v-model="occupancy.Person.Givenname" @blur="setPersonNames" />
										<span class="error" v-if="errors[0]">{{ errors[0] }}</span>
									</ValidationProvider>
								</div>
								<div class="mdl-cell mdl-cell--3-col mdl-cell--6-col-m form-group">
									<ValidationProvider rules="required|min:2|alpha_spaces" v-slot="{ errors }">
										<input :name="'lastname'" type="text" class="mdl-textfield__input" data-lpignore="true" :placeholder="T('lastname')" v-model="occupancy.Person.Lastname" @blur="setPersonNames" />
										<span class="error" v-if="errors[0]">{{ errors[0] }}</span>
									</ValidationProvider>
								</div>
								<div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-m form-group" v-if="false && hasExtendedTravelerData">
									<div class="travelerExtended">
										<input type="checkbox" v-model="occupancy.hasExtendedData" :id="`traveler_extended_${pIndex}_${oIndex}`" /><label :for="`traveler_extended_${pIndex}_${oIndex}`">{{ T("different_email_address") }}</label>
									</div>
								</div>
								<div class="mdl-cell mdl-cell--4-col mdl-cell--12-col-m form-group" v-if="false && (Reservation.ProductsPerUnit.length > 1 || product.Occupancy.length > 1) && pIndex === 0 && oIndex === 0 && hasSameTravelerData">
									<div class="travelerExtended">
										<input type="checkbox" v-model="occupancy.hasSameTravelerData" @click="toggleSameTravelerData(occupancy)" :id="`traveler_same_${pIndex}_${oIndex}`" /><label :for="`traveler_same_${pIndex}_${oIndex}`">{{ T("ticketing_data_is_same") }}</label>
									</div>
								</div>
								<div class="mdl-cell mdl-cell--8-col mdl-cell--12-col-m form-group" v-if="false && occupancy.hasExtendedData && isFieldActive(Channel.Fields.TravelerEmail)">
									<ValidationProvider name="email_" :rules=" Channel.Fields.TravelerEmail.IsRequired ? 'required|email' : 'email'" v-slot="{ errors }">
										<input name="email_deviant" type="email" class="mdl-textfield__input" data-lpignore="true" :placeholder="T('email')" v-model.trim="occupancy.Person.Communication.Email" autocomplete="off" />
										<span class="error" v-if="errors[0]">{{ errors[0] }}</span>
									</ValidationProvider>
								</div>
								<div class="mdl-cell mdl-cell--4-col hide-on-mobile form-group">
									&nbsp;
								</div>
								<div class="mdl-cell mdl-cell--8-col mdl-cell--12-col-m form-group" v-if="false && occupancy.hasExtendedData && isFieldActive(Channel.Fields.TravelerAddress)">
									<ValidationProvider :rules="Channel.Fields.TravelerAddress.IsRequired ? { regex: /[a-zA-Z0-9.]+\s\d/, required: false, min: 5 } : { regex: /[a-zA-Z0-9.]+\s\d/, required: false, min: 5 }" v-slot="{ errors }">
										<input name="street_and_street_number" type="text" class="mdl-textfield__input" @keyup="removeUnallowedCharacters" data-lpignore="true" :placeholder="T('street_and_street_number')" v-model.trim="occupancy.Person.Address" autocomplete="off" />
										<span class="error" v-if="errors[0]">{{ errors[0] }}</span>
									</ValidationProvider>
								</div>
								<div class="mdl-cell mdl-cell--4-col hide-on-mobile form-group">
									&nbsp;
								</div>
								<div class="mdl-cell mdl-cell--2-col mdl-cell--4-col-m form-group" v-if="false && occupancy.hasExtendedData && isFieldActive(Channel.Fields.TravelerPostalCode)">
									<ValidationProvider :rules="Channel.Fields.TravelerPostalCode.IsRequired ? 'required' : ''" v-slot="{ errors }">
										<input name="Address.ZIP" type="text" class="mdl-textfield__input" data-lpignore="true" :placeholder="T('Address.ZIP')" v-model="occupancy.Person.PostalCode" autocomplete="off" />
										<span class="error" v-if="errors[0]">{{ errors[0] }}</span>
									</ValidationProvider>
								</div>
								<div class="mdl-cell mdl-cell--6-col mdl-cell--8-col-m form-group" v-if="false && occupancy.hasExtendedData && isFieldActive(Channel.Fields.TravelerCity)">
									<ValidationProvider :rules="Channel.Fields.TravelerCity.IsRequired ? 'required' : ''" v-slot="{ errors }">
										<input name="location" type="text" class="mdl-textfield__input" data-lpignore="true" :placeholder="T('location')" v-model="occupancy.Person.City" autocomplete="off" />
										<span class="error" v-if="errors[0]">{{ errors[0] }}</span>
									</ValidationProvider>
								</div>
							</div>
						</template>
					</template>
				</template>
			</div>
		</template>
	</div>
</template>

<script>
	import baseMixin from "@/mixins/base";
	import {
		ValidationProvider
	} from "vee-validate";
	export default {
		name: "d21-checkout-productset",
		mixins: [baseMixin],
		components: {
			ValidationProvider
		},
		props: {
			hasExtendedTravelerData: {
				type: Boolean,
				required: true
			},
			channel: {
				type: Object,
				required: true
			},
		},
		data() {
			return {
				showEachSet: false
			}
		},
		computed: {
			groupedSets() {
				let groups = [];
				this.Reservation.MultiDate.Sets.forEach(set => {
					let key = this.getProductNames(set);
					let existing = groups.find(g => g.key === key);
					if (!this.showEachSet && existing) {
						existing.name += `, ${set.Content.Name}`;
						existing.sets.push(set);
					} else {
						groups.push({
							key: key,
							name: set.Content.Name,
							sets: [set],
							products: set.Products
						});
					}
				});
				return groups;
			}
		},
		methods: {
			getProductNames(set) {
				let txt = "";
				let products = set.Products || set.products;
				products.forEach((p, pX) => {
					if (pX > 0) txt += ", ";
					const tariff = p.Tariffs.find(t=> t.Info._uuid ===  p.Tariff);
					const name = tariff ? tariff.Info.Content.Name.trim() : p.Content.Name.split('-')[1].trim();
					txt += `${p.Count}x${name}`;
				});
				return txt;
			},
			setPersonNames() {
				if (!this.showEachSet) {
					this.groupedSets.forEach(groupedSet => {
						groupedSet.sets.forEach((set, setX) => {
							if (setX > 0) {
								set.Products.forEach((product, productX) => {
									product.Tariffs.forEach((tariff, tariffX) => {
										tariff.Occupancy.forEach((occupancy, occupancyX) => {
											occupancy.Person.Givenname = groupedSet.sets[0].Products[productX].Tariffs[tariffX].Occupancy[occupancyX].Person.Givenname;
											occupancy.Person.Lastname = groupedSet.sets[0].Products[productX].Tariffs[tariffX].Occupancy[occupancyX].Person.Lastname;
										})
									})
								});
							}
						});
					});
				}
			}
		}
	}
</script>